import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;

export const FETCH_API_INFO_SUCCESS = "FETCH_API_INFO_SUCCESS";
export const FETCH_API_LOGS_SUCCESS = "FETCH_API_LOGS_SUCCESS";

export const getApiInfo = () => axios.get(`${apiUrl}info`);

export const getApiLogs = () => axios.get(`${apiUrl}logs`);

export const getApiLogItem = (name) => axios.get(`${apiUrl}logs/${name}`);
